import styled from 'styled-components';
import { Colors } from '../../../consts';
import { sansSerif } from '../../../helpers';
export var HTMLInputElementBaseSkin = styled.input.withConfig({
  displayName: "HTMLInputElementBaseSkinskin__HTMLInputElementBaseSkin",
  componentId: "sc-1uz0qu3-0"
})(["", ";font-size:16px;line-height:22px;letter-spacing:0.00937em;text-decoration:inherit;text-transform:inherit;width:100%;height:30px;padding:20px 0 1px;transition:opacity 180ms cubic-bezier(0.4,0,0.2,1);border:none;border-bottom:1px solid;border-radius:0;background:none;appearance:none;color:", ";", "::placeholder{color:transparent;}::-moz-placeholder{color:transparent;}&:focus{outline:none;}&:invalid{box-shadow:none;}&:hover{border-bottom-color:", ";}border-bottom-color:", ";:-webkit-autofill,:-webkit-autofill:hover,:-webkit-autofill:focus,:-webkit-autofill:active{transition:background-color 5000s ease-in-out 0s,color 5000s ease-in-out 0s;}::-ms-clear{display:none;}"], sansSerif, function (_ref) {
  var disabled = _ref.disabled;
  return !disabled ? '#505050' : '#9d9d9d';
}, function (_ref2) {
  var disabled = _ref2.disabled;

  if (disabled) {
    return "-webkit-text-fill-color: #9d9d9d;";
  }
}, function (_ref3) {
  var disabled = _ref3.disabled,
      showError = _ref3.showError;
  return !disabled && showError ? Colors.RED : 'rgba(0,0,0,.87)';
}, function (_ref4) {
  var disabled = _ref4.disabled,
      showError = _ref4.showError;
  return !disabled && showError ? Colors.RED : 'rgba(0,0,0,.42)';
});